import React, { useMemo, Suspense
// Component,
// ErrorInfo,
// ReactNode,
} from 'react';
// import s from './LiquidWidget.module.scss';
// import withMarkdownStyles from '../shared/WithMarkdown/WithMarkdown.module.scss';
import { Loader, Box } from '@wix/design-system';
// import cn from 'classnames';
import { getGeneratedComponent } from './getGeneratedComponent';
// import { LiquidWidgetData } from '@wix/common-widget-types';
import { WidgetLayout } from '../shared/WidgetLayout/WidgetLayout';
import { CardLayout } from '../shared/CardLayout/CardLayout';
// import { Picture } from '../shared/Picture/Picture';
// import { WithDisabledControl } from '../../../shared/disabled-widget/WithDisabledControl';
// import { WithMarkdown } from '../shared/WithMarkdown/WithMarkdown';
// import { WidgetButton } from '../shared/WidgetButton/WidgetButton';
// import { WithDisabledControl } from '../../../shared/disabled-widget/WithDisabledControl';
// import { WithMarkdown } from '../shared/WithMarkdown/WithMarkdown';
// import { WidgetButton } from '../shared/WidgetButton/WidgetButton';

// Default bundled component ESM string - a simple example component
const DEFAULT_BUNDLED_COMPONENT_ESM_STRING = `
const { React } = window.AI_ASSISTANT_LIQUID_WIDGET;

const DefaultLiquidComponent = ({ onSendUserMessage }) => {
  const handleClick = (message) => {
    if (onSendUserMessage) {
      onSendUserMessage({ message });
    }
  };

  return React.createElement('div', {
    style: {
      padding: '16px',
      border: '1px solid #e0e0e0',
      borderRadius: '8px',
      backgroundColor: '#f9f9f9',
      textAlign: 'center'
    }
  },
    React.createElement('h3', {
      style: { margin: '0 0 12px 0', color: '#333' }
    }, 'Default Liquid Widget'),
    React.createElement('p', {
      style: { margin: '0 0 16px 0', color: '#666', fontSize: '14px' }
    }, 'This is a default component. Replace the bundledComponentEsmString to customize.'),
    React.createElement('button', {
      onClick: () => handleClick('Hello from liquid widget!'),
      style: {
        padding: '8px 16px',
        backgroundColor: '#007bff',
        color: 'white',
        border: 'none',
        borderRadius: '4px',
        cursor: 'pointer',
        fontSize: '14px'
      }
    }, 'Send Message')
  );
};

export default DefaultLiquidComponent;
`;
/*
interface ErrorBoundaryState {
  hasError: boolean;
  error?: Error;
}

interface ErrorBoundaryProps {
  children: ReactNode;
}

import React, { useMemo, Suspense } from 'react';
import { WidgetComponent } from '../../../types';

import s from './LiquidWidget.module.scss';
import withMarkdownStyles from '../shared/WithMarkdown/WithMarkdown.module.scss';
import { Loader, Box } from '@wix/design-system';
import cn from 'classnames';
import {
  GeneratedComponentProps,
  getGeneratedComponent,
} from './getGeneratedComponent';
import { LiquidWidgetData } from '@wix/common-widget-types';

export const LiquidWidget: WidgetComponent<LiquidWidgetData> = ({
  data,
  context,
}) => {
  const LazyComponent = useMemo(() => {
    // @ts-expect-error
    window.AI_ASSISTANT_LIQUID_WIDGET = { React };

    // return lazy(() => import('./GeneratedComponentMock'));
    return getGeneratedComponent(data.bundledComponentEsmString);
  }, [data.bundledComponentEsmString]);

  const handleSendUserMessage: GeneratedComponentProps['onSendUserMessage'] = ({
    message,
  }) => {
    if (message && typeof message === 'string') {
      context.send(message);
    }
  };

  return (
    <div className={cn(s.container, withMarkdownStyles.container)}>
      <Suspense
        fallback={
          <Box align="center" width="100%">
            <Loader size="small" />
          </Box>
        }
      >
        <LazyComponent onSendUserMessage={handleSendUserMessage} />
      </Suspense>
    </div>
  );
};

export const LIQUID_WIDGET = 'LIQUID_WIDGET';


class ComponentErrorBoundary extends Component<
  ErrorBoundaryProps,
  ErrorBoundaryState
> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error: Error): ErrorBoundaryState {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error(
      'LiquidWidget ComponentErrorBoundary caught an error:',
      error,
      errorInfo,
    );
  }

  render() {
    if (this.state.hasError) {
      return (
        <Text size="tiny" secondary>
          Component failed to render
        </Text>
      );
    }

    return this.props.children;
  }
}
*/
export const LiquidWidget = _ref => {
  var _data$secondaryButton, _data$secondaryButton2, _data$primaryButton;
  let {
    data,
    context
  } = _ref;
  const LazyComponent = useMemo(() => {
    // @ts-expect-error
    window.AI_ASSISTANT_LIQUID_WIDGET = {
      React
    };

    // return lazy(() => import('./GeneratedComponentMock'));
    return getGeneratedComponent(data.bundledComponentEsmString || DEFAULT_BUNDLED_COMPONENT_ESM_STRING);
  }, [data.bundledComponentEsmString]);
  const handleSendUserMessage = _ref2 => {
    let {
      message
    } = _ref2;
    if (message && typeof message === 'string') {
      context.send(message);
    }
  };
  const cards = [/*#__PURE__*/React.createElement(CardLayout, {
    borderless: true
  }, /*#__PURE__*/React.createElement(Box, {
    align: "space-between",
    verticalAlign: "middle",
    gap: "SP1"
  }, /*#__PURE__*/React.createElement(Suspense, {
    fallback: /*#__PURE__*/React.createElement(Box, {
      align: "center",
      width: "100%"
    }, /*#__PURE__*/React.createElement(Loader, {
      size: "small"
    }))
  }, /*#__PURE__*/React.createElement(Box, {
    width: "100%"
  }, /*#__PURE__*/React.createElement(LazyComponent, {
    onSendUserMessage: handleSendUserMessage
  })))))];
  const getPrimaryButtonMessage = () => {
    try {
      // @ts-expect-error
      return window.LIQUID_WIDGET_PRIMARY_BUTTON_MESSAGE || '';
    } catch (error) {
      return '';
    }
  };
  const getSecondaryButtonMessage = () => {
    try {
      // @ts-expect-error
      return window.LIQUID_WIDGET_SECONDARY_BUTTON_MESSAGE || '';
    } catch (error) {
      return '';
    }
  };
  return /*#__PURE__*/React.createElement(WidgetLayout, {
    text: data.title,
    secondaryButton: {
      label: ((_data$secondaryButton = data.secondaryButton) == null ? void 0 : _data$secondaryButton.title) ?? '',
      webAction: {
        externalNavigateTo: {
          url: ((_data$secondaryButton2 = data.secondaryButton) == null ? void 0 : _data$secondaryButton2.navigateTo) ?? '',
          openInCurrentTab: false
        }
      }
    },
    primaryButton: {
      label: ((_data$primaryButton = data.primaryButton) == null ? void 0 : _data$primaryButton.title) ?? ''
    },
    onPrimaryButtonClick: () => {
      var _data$primaryButton2;
      context.send(getPrimaryButtonMessage() || ((_data$primaryButton2 = data.primaryButton) == null ? void 0 : _data$primaryButton2.message));
    },
    onSecondaryButtonClick: () => {
      var _data$secondaryButton3;
      context.send(getSecondaryButtonMessage() || ((_data$secondaryButton3 = data.secondaryButton) == null ? void 0 : _data$secondaryButton3.message));
    },
    context: context,
    gap: "big",
    onEnableControls: () => {},
    disabled: false
  }, cards);
};
export const LIQUID_WIDGET = 'LIQUID_WIDGET';
//# sourceMappingURL=LiquidWidget.js.map